// extracted by mini-css-extract-plugin
export var skipAnimation = "_s-0";